import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { SectionHeading } from './SectionHeading';
import { BONUS_TOTAL, CHECKOUT_URL, PACK_IMAGE, PACK_IMAGE_ALT, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-2 bg-mist" data-id="element-100" data-mp="dend4uk4kl6y">
      <div className="mx-auto max-w-xl px-4 py-6 sm:px-6 sm:py-8" data-id="element-101" data-mp="idi0m9t1exxe">
        <SectionHeading id="oferta-titulo" eyebrow="Oferta especial — Sistema completo 6 en 1" title="Comienza hoy desde cero y avanza a tu ritmo." data-id="element-102" data-mp="ifb3de0j4y04" />

        <Reveal className="mt-4 rounded-2xl border-[3px] border-dashed border-navy bg-white p-4 text-center" data-id="element-103" data-mp="repsoa4yn2j1">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" aria-label={`Comprar el Mega Pack por ${PRICE}`} className="mx-auto block max-w-[15rem]" data-id="element-104" data-mp="wan6a8ou9us4">
            <img src={PACK_IMAGE} alt={PACK_IMAGE_ALT} className="w-full" data-id="element-105" data-mp="12o1rms1ygi2r" />
          </a>

          <p className="mt-1 font-display text-sm font-extrabold leading-tight text-navy sm:text-base" data-id="element-106" data-mp="xx1v3nwr020s">
            🛡️ {PRODUCT_NAME}
          </p>
          <p className="font-display text-sm font-bold text-graphite-muted" data-id="element-107" data-mp="sy8ma8seoz6y">
            6 Tomos + 5 Bonos
          </p>
          <p className="mt-1.5 font-display text-xs font-bold text-graphite" data-id="element-108" data-mp="ouaj9mzyn48m">
            🎁 Bonos valorados en {BONUS_TOTAL}
          </p>

          <p className="mt-2 inline-block rounded-md bg-navy px-3 py-1 font-display text-[0.7rem] font-bold uppercase tracking-wide text-gold" data-id="element-109" data-mp="1gn1i8591371k">
            🔥 Oferta especial
          </p>
          <p className="mt-1 font-display text-4xl font-black leading-none text-navy sm:text-5xl" data-id="element-110" data-mp="17n4ohp7s7hzn">
            <span className="align-middle text-lg font-extrabold text-graphite-muted sm:text-xl" data-id="element-111" data-mp="172gbbq0879r">
              Hoy:{' '}
            </span>
            {PRICE}
          </p>
          <p className="mt-1.5 font-display text-[0.7rem] font-bold text-graphite-muted sm:text-xs" data-id="element-112" data-mp="3sf6qqux0i6cs">
            Pago único • Sin mensualidades • Acceso Digital
          </p>

          <CtaButton href={CHECKOUT_URL} external className="mt-3" note="Acceso Inmediato • Garantía de 7 Días" data-id="element-113" data-mp="2mwyzbyn7ybc">
            🚀 SÍ, QUIERO EL MEGA PACK COMPLETO POR {PRICE}
          </CtaButton>
        </Reveal>
      </div>
    </section>;
}